import {
  FieldWrapper,
  Label,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@commenda/kakashi';
import {
  DemoAIFillingType,
  TDemoAIFillingAgentStepDefinition,
  WorkflowStepType,
} from '@commenda/types';
import { useWorkflow } from '../../context/WorkflowContext';
import { TSelectedEntity } from '../../types/node';

const FILING_TYPE_OPTIONS = [
  {
    value: DemoAIFillingType.TM01_DIRECTOR_TERMINATION,
    label: 'TM01 — Director Termination',
  },
  {
    value: DemoAIFillingType.UBO_PSC_UPDATE,
    label: 'UBO / PSC Update',
  },
  {
    value: DemoAIFillingType.VERIFY_SALES_TAX_CREDENTIALS,
    label: 'Verify Sales Tax Credentials',
  },
];

export const DemoAIFillingAgentNodePropertyPanel = ({
  selectedEntity,
}: {
  selectedEntity: TSelectedEntity;
}) => {
  const { workflow, setWorkflow } = useWorkflow();

  const selectedStep = workflow?.steps.find(
    (step) => step.id === selectedEntity.id
  ) as TDemoAIFillingAgentStepDefinition | undefined;

  if (!selectedStep) return <div>Step not found</div>;

  const config = selectedStep.aiFillingAgent ?? {
    filingType: undefined,
    dataFromStepId: undefined,
  };

  const updateConfig = (
    updates: Partial<TDemoAIFillingAgentStepDefinition['aiFillingAgent']>
  ) => {
    setWorkflow({
      ...workflow,
      steps: workflow?.steps.map((step) =>
        step.id === selectedEntity.id
          ? { ...step, aiFillingAgent: { ...config, ...updates } }
          : step
      ),
    });
  };

  const humanFormSteps = workflow?.steps.filter(
    (step) =>
      step.id !== selectedEntity.id &&
      step.type === WorkflowStepType.HUMAN_FORM
  );

  return (
    <div className="flex flex-col gap-4">
      <FieldWrapper>
        <Label>Filing Type</Label>
        <Select
          value={config.filingType || ''}
          onValueChange={(value) =>
            updateConfig({ filingType: value as DemoAIFillingType })
          }
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a filing type" />
          </SelectTrigger>
          <SelectContent>
            {FILING_TYPE_OPTIONS.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FieldWrapper>

      <FieldWrapper>
        <Label>Use Data From Step</Label>
        <Select
          value={config.dataFromStepId || ''}
          onValueChange={(value) => updateConfig({ dataFromStepId: value })}
        >
          <SelectTrigger>
            <SelectValue placeholder="Select a step" />
          </SelectTrigger>
          <SelectContent>
            {humanFormSteps?.map((step) => (
              <SelectItem key={step.id} value={step.id}>
                {step.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </FieldWrapper>
    </div>
  );
};
